import { RightsTypeMap, WORRY_FREE_RIGHT_POPINFO_DATA } from '@/common/constant'

export default {
  /**
   * @description: 限制差旅城市列表
   * @param {*} state
   * @return {Array}
   */
  cityList(state, getters) {
    return getters.travelInfo?.end_city_list ?? []
  },
  // 中转第二程索引
  curTransferIndex(state) {
    const index = state.ticketData?.[1]?.findIndex(ticket => ticket?.seat_type_name === state.selectSeatInfo?.[1]?.seat_type_name) || 0
    return index === -1 ? 0 : index
  },
  worryfreeRightInfo(state) {
    const rightInfoArr = state.selectSeatInfo.map((item) => {
      return item?.service_info?.serviceInfoList || []
    })
    const _worryfreeRightInfo =
      rightInfoArr?.[0]?.find((item) => item.type === RightsTypeMap.worryfree) || {}
    return _worryfreeRightInfo
  },
  // 退改无忧弹层数据，选中坐席的退改无忧配置数据
  worryfreeRightPopupInfo(state, getter) {
    const {
      pop_title,
      pop_sub_title,
      image_list,
      text_list
    } = getter.worryfreeRightInfo
    return {
      pop_title: pop_title || WORRY_FREE_RIGHT_POPINFO_DATA.pop_title,
      pop_sub_title: pop_sub_title || WORRY_FREE_RIGHT_POPINFO_DATA.pop_sub_title,
      image_list: image_list || WORRY_FREE_RIGHT_POPINFO_DATA.image_list,
      text_list: text_list || WORRY_FREE_RIGHT_POPINFO_DATA.text_list,
    }
  }
}
